module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contentWrap"
    }
  }, [_c('div', {
    staticClass: "content right"
  }, [_c('div', {
    staticClass: "right",
    attrs: {
      "id": "content_1block"
    }
  }, [_c('div', {
    staticClass: "response"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "response_block right linkfont"
  }, [_vm._v("خوش آمدید! شما با موفقیت ثبت نام نموده اید. یک ایمیل جهت اعتبارسنجی برای شما ارسال می گردد. "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v("خواهشمند است روی لینک موجود در ایمیل کلیک نمایید تا حساب کاربری شما فعال گردد. با تشکر\n          "), _c('p', [_vm._v("درصورت عدم دریافت ایمیل، لطفا کلیک کنید روی "), _c('a', {
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        _vm.ResendMail()
      }
    }
  }, [_vm._v("اینجا")]), _vm._v(" تا ایمیل دوباره ارسال گردد.")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "200px",
      "margin-right": "auto",
      "margin": "auto"
    }
  }, [_c('button', {
    staticClass: "button-warning pure-button button-download",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("بازگشت به صفحه اصلی")])])])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "response_icon right"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/succesful_icon.png"),
      "width": "42",
      "height": "42",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0bc9c144!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/RegisterResult.vue
// module id = 100
// module chunks = 1